import {IonList, IonListHeader, IonItem, IonLabel, IonAvatar, IonIcon, IonButton, IonSearchbar} from '@ionic/react';
import React, { useState,useEffect, useContext } from 'react';
import {mapOutline, locationOutline, openOutline } from 'ionicons/icons'
import './ListItems.css';
import { navigationWarningsTranslations } from '../translations/navigationWarnings';
import { LanguageContext } from '../contexts/LanguageContext';
interface ContainerProps {
  name: string;
  elements: any[] | null;
}

const ListItems: React.FC<ContainerProps> = ({ name, elements }) => {

  const [searchText, setSearchText] = useState('');
  const [hiddenElements, setHiddenElements] = useState<[any] | null>(null);

  const urlMap10k = "https://www.adbpo.it/download/CartaPo10k_edizione2008/CartaPo10k_Tavole_pdf/";
  const urlMap50k = "https://www.adbpo.it/download/Cartog50K_PO_Portolano/";
  const { language } = useContext(LanguageContext);
  const t = navigationWarningsTranslations[language];

  useEffect(() => {

    let hiddenElementsArray:[number] = [-1]; // define array of elements to be hidden

    if (elements != null) // this is still generic
    {
      // console.log("Text: "+searchText.toLowerCase());

      // filter based on input text and depending on what list are we looking at
      switch(name)
      {
          case "Attracchi":
            elements.map((element, index) => {
               if ( element.name.toLowerCase().search(searchText.toLowerCase()) == -1 &&      // search in dock name
                    element.village.toLowerCase().search(searchText.toLowerCase()) == -1 &&   // search in dock village
                    element.city.toLowerCase().search(searchText.toLowerCase()) == -1 &&      // search in dock province
                    `${element.km_tab}`.search(searchText.toLowerCase()) == -1)               // search in dock km
                 hiddenElementsArray.push(index); // hide elements
            });
          break;

          case "Carte del Fiume Po":
             elements.map((element, index) => {
                if (element.name.toLowerCase().search(searchText.toLowerCase()) == -1)  // search text
                  hiddenElementsArray.push(index); // hide elements
             });
           break;

           case "Riserve della Biosfera":
              elements.map((element, index) => {
                if ( element.title.toLowerCase().search(searchText.toLowerCase()) == -1 &&         // search in island link name
                     (!element.description || element.description.toLowerCase().search(searchText.toLowerCase()) == -1) &&   // search in island link description
                     (!element.province || element.province.toLowerCase().search(searchText.toLowerCase()) == -1) &&      // search in island link province
                     element.region_name.toLowerCase().search(searchText.toLowerCase()) == -1 ||    // search in island link region
                     !element.province)
                   hiddenElementsArray.push(index); // hide elements
              });
            break;

          case "Avvisi di cauta navigazione":
            elements.map((element, index) => {
              const title = (element.title || '').toLowerCase();
              const body = (element.body || '').toLowerCase();
              const badge = Number(element.danger_zone_id) > 0 ? (t.dangerZoneBadge || '').toLowerCase() : '';
              if (title.search(searchText.toLowerCase()) === -1 &&
                  body.search(searchText.toLowerCase()) === -1 &&
                  badge.search(searchText.toLowerCase()) === -1) {
                hiddenElementsArray.push(index);
              }
            });
          break;
        }
      }

      // console.log("to hide: ",hiddenElementsArray);
      setHiddenElements(hiddenElementsArray); // set array of elements to be hidden
    }, [elements, searchText, t, language])

  switch(name)
  {
    case "Attracchi":
    return (
      <>
      <IonSearchbar placeholder="Cerca attracco" showCancelButton="never" value={searchText} onIonChange={e => setSearchText(e.detail.value!)} animated={true} ></IonSearchbar>
        <IonList>
          {elements != null &&
            elements.map((element, index) => {
              return (
                <span key={index}>
                {(hiddenElements == null || hiddenElements.indexOf(index) == -1) && // show only elements not in the array
                  <IonItem button={true} routerLink={`/dock/${index}`} >
                   {/*<IonAvatar slot="start">
                     <img src="./avatar-finn.png" />
                   </IonAvatar>*/}
                   <IonLabel>
                     <h2>{element.name}</h2>
                     <h3>{element.village} ({element.province})</h3>
                     <p>km {element.km_tab}</p>
                   </IonLabel>
                   {/* <IonButton routerLink={`/docksMap/dock/${index}`} fill="clear" size="large">
                    <IonIcon slot="end" icon={locationOutline} className="dockButton" ></IonIcon>
                   </IonButton> */}
                 </IonItem>
               }
               </span>
              )
           })
         }
        </IonList>
      </>
    );
    case "Carte del Fiume Po":
    return (
      <>
        <IonSearchbar placeholder="Cerca mappa" showCancelButton="never" value={searchText} onIonChange={e => setSearchText(e.detail.value!)} animated={true} ></IonSearchbar>
        <IonList>
          {elements != null &&
            elements.map((element, index) => {
              return (
                <span key={index}>
                {(hiddenElements == null || hiddenElements.indexOf(index) == -1) && // show only elements not in the array
                  <IonItem key={index} button={false} >
                   <IonLabel>
                     <h2 className="mapLabels">
                      {element.map.indexOf("10K") > -1 ? element.name.substr(31) : element.name.substr(19)}
                     </h2>
                   </IonLabel>
                   <IonButton target="_blank" rel="noreferrer" href={(element.map.indexOf("10K") > -1 ? urlMap10k : urlMap50k) + element.map} fill="clear" size="large">
                    <IonIcon slot="end" icon={mapOutline} className={(element.map.indexOf("10K") > -1 ? "mapButton10k" : "mapButton50k")}></IonIcon>
                   </IonButton>
                 </IonItem>
               }
               </span>
              )
           })
         }
        </IonList>
      </>
    );
    case "Riserve della Biosfera":
    return (
      <>
        <IonSearchbar placeholder="Cerca area naturalistica" showCancelButton="never" value={searchText} onIonChange={e => setSearchText(e.detail.value!)} animated={true} ></IonSearchbar>
        <IonList>
          {elements != null &&
            elements.map((element, index) => {
              return (
                <span key={index}>
                {(hiddenElements == null || hiddenElements.indexOf(index) == -1) && // show only elements not in the array
                  <IonItem key={index} button={false} >
                   <IonLabel>
                     <h2>{element.title}</h2>
                   </IonLabel>
                   <IonButton target="_blank" rel="noreferrer" href={element.url} fill="clear" size="large">
                    <IonIcon slot="end" icon={openOutline} ></IonIcon>
                   </IonButton>
                 </IonItem>
               }
               </span>
              )
           })
         }
        </IonList>
      </>
    );
    case "Avvisi di cauta navigazione":
    return (
      <>
        <IonSearchbar placeholder="Cerca avviso cauta navigazione" showCancelButton="never" value={searchText} onIonChange={e => setSearchText(e.detail.value!)} animated={true} ></IonSearchbar>
        <IonList>
          {elements != null &&
            elements.map((element, index) => {
              return (
                <span key={index}>
                {(hiddenElements == null || hiddenElements.indexOf(index) == -1) && // show only elements not in the array
                  <IonItem key={index} button={false} className="nav-warning-item" lines="full">
                    <IonLabel className="wrap-text nav-warning-item-content">
                      <h2>{element.title}{Number(element.danger_zone_id) > 0 ? ` (${t.dangerZoneBadge})` : ''}</h2>
                      {element.body ? <h3>{element.body}</h3> : null}
                      <p>{Number(element.danger_zone_id) > 0 ? t.dangerZonePublication : (element.lat > 0 ? t.warningDate : t.notificationDate)} {new Date(element.published_at || element.created_at).toLocaleString(language === 'en' ? 'en-GB' : 'it-IT', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}</p>
                      {(Number(element.lat) > 0 || Number(element.danger_zone_id) > 0) &&
                        <div className="nav-warning-map-btn-wrap">
                          <IonButton routerLink={`/docksMap/warning/${index}`} fill="outline" size="small" className="nav-warning-map-btn">
                            <IonIcon slot="start" icon={locationOutline} className="dockButton" />
                            <IonLabel>{t.showOnMap}</IonLabel>
                          </IonButton>
                        </div>
                      }
                    </IonLabel>
                  </IonItem>
                }
                </span>
              )
            })
          }
        </IonList>
      </>
    );

    default:
      return (
        <div className="container">
          <strong>{name}</strong>
        </div>
      );
  }

};

export default ListItems;
